export type MrclTextTagStyle =
  | "p"
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "display"
  | "subtitle"
  | "caption";

export type MrclTextSize = "s" | "m" | "l";

export const getMrclTextClassName = (
  tagStyle: MrclTextTagStyle = "p",
  size: MrclTextSize = "m",
  bold = false
): string => {
  const variant = (regular: string, boldClass: string) => (bold ? boldClass : regular);

  switch (tagStyle) {
    case "h1":
      return "mrcl-title-l";
    case "h2":
      return "mrcl-title-m";
    case "h3":
      return "mrcl-title-xs";
    case "h4":
      return "mrcl-title-2xs";
    case "display":
      return size === "l" ? "mrcl-title-2xl" : "mrcl-title-xl";
    case "subtitle":
      return size === "m"
        ? variant("mrcl-title-xs-regular", "mrcl-title-xs")
        : variant("mrcl-title-2xs-regular", "mrcl-title-2xs");
    case "caption":
      return variant("mrcl-body-xs-regular", "mrcl-body-xs-bold");
    case "p":
    default:
      return size === "s"
        ? variant("mrcl-body-s-regular", "mrcl-body-s-bold")
        : variant("mrcl-body-m-regular", "mrcl-body-m-bold");
  }
};
